import { useState } from "react";
import { Play } from "lucide-react";
import { Reveal } from "@/components/Reveal";

// Set to the launch film URL once uploaded — the section stays hidden until then.
const VIDEO_URL = "/film/eden-launch.mp4";
const POSTER = "/film/eden-launch-poster.jpg";

const copy = {
  en: {
    eyebrow: "THE EDEN FILM",
    title: <>Watch how we <em>reimagined</em> villa care.</>,
    caption: "Our launch film · sound on",
  },
  id: {
    eyebrow: "FILM EDEN",
    title: <>Saksikan bagaimana kami <em>menata ulang</em> perawatan villa.</>,
    caption: "Film peluncuran kami · nyalakan suara",
  },
};

export const FilmSection = ({ lang }) => {
  const [playing, setPlaying] = useState(false);
  const t = copy[lang];

  if (!VIDEO_URL) return null;

  return (
    <section className="film section" data-testid="film-section">
      <Reveal className="film-head">
        <p className="eyebrow">{t.eyebrow}</p>
        <h2>{t.title}</h2>
      </Reveal>
      <Reveal className="film-frame" delay={0.15}>
        {!playing ? (
          <button className="film-poster" style={{ backgroundImage: `url(${POSTER})` }} onClick={() => setPlaying(true)} data-testid="film-play-button" aria-label="Play the Eden film">
            <span className="film-play"><Play size={22} fill="currentColor" /></span>
          </button>
        ) : (
          <video src={VIDEO_URL} controls autoPlay playsInline data-testid="film-video" />
        )}
      </Reveal>
      <p className="film-caption" data-testid="film-caption">{t.caption}</p>
    </section>
  );
};
